import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import DatePicker from 'react-date-picker'
import { DocumentDownloadIcon, QuestionMarkCircleIcon, SearchIcon } from '@heroicons/react/solid';
import { convert, formatDate } from '../../utils/convertDate';
import GeneralTable from '../../components/GeneralTable';
import { useNavigate } from 'react-router-dom';
import WakanowServices from '../../services/wakanowServices';

const oldFrom = new Date().setDate(new Date().getDate() - 7);
const longNew = formatDate(new Date());
const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))

const HolidayPackageRequests = () => {
    const navigate = useNavigate()

    const [search, setSearch] = useState("")
    const [too, setToo] = useState(convert(longNew));
    const [fromm, setFromm] = useState(convert(defaultFrom));
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    });

    const [filters, setFilters] = useState({
        search: '',
        fromm: convert(defaultFrom),
        too: convert(longNew),
    });

    const [pageIndex, setPageIndex] = useState(1);
    const itemsPerPage = 10;

    const [listings, setListings] = useState([]);
    const [totalListingsCount, setTotalListingsCount] = useState(0);
    const [totalPagesCount, setTotalPagesCount] = useState(0);

    const prevPage = () => {
        if (pageIndex > 1) setPageIndex(pageIndex - 1);
    };

    const nextPage = () => {
        if (pageIndex < totalPagesCount) setPageIndex(pageIndex + 1);
    }

    const columns = [
        { key: 'emailAddress', header: 'Email' },
        { key: 'adults', header: 'Adults' },
        { key: 'children', header: 'Children' },
        { key: 'preferredTravelDate', header: 'Preferred Date', render: (item) => convert(item.preferredTravelDate) },
        {
            key: 'allowWakanowHandleFlightBooking', header: 'Handle Flight', render: (item) => (
                <span className={item.allowWakanowHandleFlightBooking ? 'text-green-500 font-semibold' : 'text-red-400'}>
                    {item.allowWakanowHandleFlightBooking ? 'Yes' : 'No'}
                </span>
            )
        },
        {
            key: 'status', header: 'Status', render: (item) => {
                const s = item?.status?.toLowerCase() || '';
                const colors = {
                    'submitted': 'text-blue-500 font-semibold',
                    'approved': 'text-green-500 font-semibold',
                    'rejected': 'text-red-500 font-semibold'
                };
                return <span className={colors[s] || 'text-gray-500'}>{item.status || '-'}</span>;
            }
        },
        { key: 'dateCreated', header: 'Date Created', render: (item) => convert(item.dateCreated) }
    ];

    const GetListings = async (page, pageSize, searchTerm, startDate, endDate) => {
        try {
            const response = await WakanowServices.listHolidayPackageRequests(page, pageSize, searchTerm, startDate, endDate);
            setListings(response.data.result);
            setTotalListingsCount(response.data.totalCount);
            setTotalPagesCount(Math.ceil(response.data.totalCount / itemsPerPage));
        } catch (error) {
            setListings([]);
            setTotalListingsCount(0);
            setTotalPagesCount(0);
        }
    }

    useEffect(() => {
        GetListings(pageIndex, itemsPerPage, filters.search, filters.fromm, filters.too);
    }, [pageIndex, filters])

    const range = async (e) => {
        e.preventDefault();
        setPageIndex(1);
        setFilters({ search, fromm, too });
    }

    const clearFilters = () => {
        setSearch("");
        setFormValues({ from: new Date(oldFrom), to: new Date() });
        setFromm(convert(defaultFrom));
        setToo(convert(longNew));
        setPageIndex(1);
        setFilters({
            search: '',
            fromm: convert(defaultFrom),
            too: convert(longNew),
        });
    };

    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event });
            setFromm(event ? convert(formatDate(event)) : '');
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event });
            setToo(event ? convert(formatDate(event)) : '');
        }
    };

    const exportData = async () => {
        const resp = await WakanowServices.exportHolidayPackageRequests(filters.search, filters.fromm, filters.too);
        if (resp) {
            window.open(resp.data)
        }
    }

    const getActions = (item) => {
        return ['View Request'];
    };

    const handleActionSelect = async (action, item) => {
        if (action === "View Request") {
            navigate(`/wakanow/holiday-package-requests/${item?.holidayPackageRequestId}`)
        }
    };

    return (
        <Layout title="Holiday Package Requests" pageTag={"wakanow"} current={'/wakanow/holiday-package-requests'}>
            <React.Fragment>
                <main className='mt-5'>
                    <div className="sm:flex items-center flex-wrap">
                        <div className="sm:flex-auto flex items-center flex-wrap">
                            <div className="relative rounded-md shadow-sm">
                                <p className='text-sm leading-3 text-gray-500'>From</p>
                                <div>
                                    <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                </div>
                            </div>
                            <div className="relative rounded-md shadow-sm ml-3">
                                <p className='text-sm leading-3 text-gray-500'>To</p>
                                <div>
                                    <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                </div>
                            </div>
                            <div className='flex ml-4'>
                                <div className="mt-5 relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        onChange={(e) => setSearch(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search requests"
                                    />
                                    <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                                        <div className='tooltip'>
                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                            <span className="tooltiptext"><p>Search by email or status</p></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-5 ml-4'>
                                <button
                                    onClick={range}
                                    className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'
                                >
                                    Search
                                </button>
                            </div>
                            <div className='mt-5 ml-4'>
                                <button
                                    onClick={clearFilters}
                                    className='inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-6 py-2 text-sm font-medium text-gray-600 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'
                                >
                                    Clear filters
                                </button>
                            </div>
                        </div>

                        <div className="flex items-center mt-3">
                            <button
                                type="button"
                                onClick={exportData}
                                className="inline-flex mr-2 items-center hover:text-white active:text-white justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export
                            </button>
                        </div>
                    </div>

                    <GeneralTable
                        columns={columns}
                        data={listings}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        totalCount={totalListingsCount}
                        totalPages={totalPagesCount}
                        prevPage={prevPage}
                        setPageIndex={setPageIndex}
                        actions={getActions}
                        onActionSelect={handleActionSelect}
                    />
                </main>
            </React.Fragment>
        </Layout>
    )
}

export default HolidayPackageRequests
